module.exports = __webpack_public_path__ + "static/img/kyujin.528a68b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lp/kyujin.png
// module id = w7Dd
// module chunks = 3